import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _70f3e482 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _69d9b11a = () => interopDefault(import('../../../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _2dba634b = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _e31d807c = () => interopDefault(import('../../../pages/careers/index.vue' /* webpackChunkName: "pages/careers/index" */))
const _2742829c = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _10ba6082 = () => interopDefault(import('../../../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _395329e8 = () => interopDefault(import('../../../pages/investors/index.vue' /* webpackChunkName: "pages/investors/index" */))
const _12f1b39a = () => interopDefault(import('../../../pages/lab/index.vue' /* webpackChunkName: "pages/lab/index" */))
const _6dff6404 = () => interopDefault(import('../../../pages/onboarding/index.vue' /* webpackChunkName: "pages/onboarding/index" */))
const _2efe6e73 = () => interopDefault(import('../../../pages/prices/index.vue' /* webpackChunkName: "pages/prices/index" */))
const _b4e647c8 = () => interopDefault(import('../../../pages/promo/index.vue' /* webpackChunkName: "pages/promo/index" */))
const _1d5b5bf2 = () => interopDefault(import('../../../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _7f953a67 = () => interopDefault(import('../../../pages/solutions/index.vue' /* webpackChunkName: "pages/solutions/index" */))
const _128c7997 = () => interopDefault(import('../../../pages/subscribe/index.vue' /* webpackChunkName: "pages/subscribe/index" */))
const _acc82690 = () => interopDefault(import('../../../pages/success-story/index.vue' /* webpackChunkName: "pages/success-story/index" */))
const _1f483e5c = () => interopDefault(import('../../../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _26b502ac = () => interopDefault(import('../../../pages/tenders/index.vue' /* webpackChunkName: "pages/tenders/index" */))
const _05105542 = () => interopDefault(import('../../../pages/wp/index.vue' /* webpackChunkName: "pages/wp/index" */))
const _7d6b4a08 = () => interopDefault(import('../../../pages/about/company/index.vue' /* webpackChunkName: "pages/about/company/index" */))
const _1d82af95 = () => interopDefault(import('../../../pages/about/conference-hall/index.vue' /* webpackChunkName: "pages/about/conference-hall/index" */))
const _1f1532fe = () => interopDefault(import('../../../pages/about/contacts/index.vue' /* webpackChunkName: "pages/about/contacts/index" */))
const _62567846 = () => interopDefault(import('../../../pages/about/data-centers/index.vue' /* webpackChunkName: "pages/about/data-centers/index" */))
const _1ebc4d8d = () => interopDefault(import('../../../pages/about/details/index.vue' /* webpackChunkName: "pages/about/details/index" */))
const _72562683 = () => interopDefault(import('../../../pages/about/documents/index.vue' /* webpackChunkName: "pages/about/documents/index" */))
const _edf231ce = () => interopDefault(import('../../../pages/about/newsroom/index.vue' /* webpackChunkName: "pages/about/newsroom/index" */))
const _e9d768f8 = () => interopDefault(import('../../../pages/about/partners-offers/index.vue' /* webpackChunkName: "pages/about/partners-offers/index" */))
const _7d610156 = () => interopDefault(import('../../../pages/about/partners/index.vue' /* webpackChunkName: "pages/about/partners/index" */))
const _96decd50 = () => interopDefault(import('../../../pages/about/payments/index.vue' /* webpackChunkName: "pages/about/payments/index" */))
const _fafd8658 = () => interopDefault(import('../../../pages/careers/all/index.vue' /* webpackChunkName: "pages/careers/all/index" */))
const _38278fd0 = () => interopDefault(import('../../../pages/careers/internships/index.vue' /* webpackChunkName: "pages/careers/internships/index" */))
const _efffd7fa = () => interopDefault(import('../../../pages/lab/amd/index.vue' /* webpackChunkName: "pages/lab/amd/index" */))
const _01886b2e = () => interopDefault(import('../../../pages/lab/anklav/index.vue' /* webpackChunkName: "pages/lab/anklav/index" */))
const _94100282 = () => interopDefault(import('../../../pages/lab/arm-server/index.vue' /* webpackChunkName: "pages/lab/arm-server/index" */))
const _5812060f = () => interopDefault(import('../../../pages/lab/fpga/index.vue' /* webpackChunkName: "pages/lab/fpga/index" */))
const _b5f51f7a = () => interopDefault(import('../../../pages/lab/general-load-balancer/index.vue' /* webpackChunkName: "pages/lab/general-load-balancer/index" */))
const _7628224c = () => interopDefault(import('../../../pages/lab/mac/index.vue' /* webpackChunkName: "pages/lab/mac/index" */))
const _2787047a = () => interopDefault(import('../../../pages/services/1c-leasing/index.vue' /* webpackChunkName: "pages/services/1c-leasing/index" */))
const _58d4f6c5 = () => interopDefault(import('../../../pages/services/additional/index.vue' /* webpackChunkName: "pages/services/additional/index" */))
const _a0aab430 = () => interopDefault(import('../../../pages/services/cloud-apps/index.vue' /* webpackChunkName: "pages/services/cloud-apps/index" */))
const _aa3ae626 = () => interopDefault(import('../../../pages/services/cloud/index.vue' /* webpackChunkName: "pages/services/cloud/index" */))
const _d89f6382 = () => interopDefault(import('../../../pages/services/colocation/index.vue' /* webpackChunkName: "pages/services/colocation/index" */))
const _3b9a95a7 = () => interopDefault(import('../../../pages/services/dedicated/index.vue' /* webpackChunkName: "pages/services/dedicated/index" */))
const _7de1d708 = () => interopDefault(import('../../../pages/services/is/index.vue' /* webpackChunkName: "pages/services/is/index" */))
const _0c448781 = () => interopDefault(import('../../../pages/solutions/cdn-infrastructure/index.vue' /* webpackChunkName: "pages/solutions/cdn-infrastructure/index" */))
const _1e660fce = () => interopDefault(import('../../../pages/solutions/cloud-migration/index.vue' /* webpackChunkName: "pages/solutions/cloud-migration/index" */))
const _1b203170 = () => interopDefault(import('../../../pages/solutions/data-center/index.vue' /* webpackChunkName: "pages/solutions/data-center/index" */))
const _2fdf3b78 = () => interopDefault(import('../../../pages/solutions/gpu/index.vue' /* webpackChunkName: "pages/solutions/gpu/index" */))
const _6a50873c = () => interopDefault(import('../../../pages/solutions/hybrid-cloud/index.vue' /* webpackChunkName: "pages/solutions/hybrid-cloud/index" */))
const _32f43828 = () => interopDefault(import('../../../pages/solutions/hybrid-infrastructure/index.vue' /* webpackChunkName: "pages/solutions/hybrid-infrastructure/index" */))
const _1bb20987 = () => interopDefault(import('../../../pages/solutions/hyperserver/index.vue' /* webpackChunkName: "pages/solutions/hyperserver/index" */))
const _0803de6e = () => interopDefault(import('../../../pages/solutions/it-cost-optimization/index.vue' /* webpackChunkName: "pages/solutions/it-cost-optimization/index" */))
const _a6927eec = () => interopDefault(import('../../../pages/solutions/managed-services/index.vue' /* webpackChunkName: "pages/solutions/managed-services/index" */))
const _58488ef9 = () => interopDefault(import('../../../pages/solutions/multi-cloud/index.vue' /* webpackChunkName: "pages/solutions/multi-cloud/index" */))
const _7b46a916 = () => interopDefault(import('../../../pages/solutions/pdps/index.vue' /* webpackChunkName: "pages/solutions/pdps/index" */))
const _a9899f6e = () => interopDefault(import('../../../pages/solutions/resilient-infrastructure/index.vue' /* webpackChunkName: "pages/solutions/resilient-infrastructure/index" */))
const _2b8eee68 = () => interopDefault(import('../../../pages/solutions/video-analytics/index.vue' /* webpackChunkName: "pages/solutions/video-analytics/index" */))
const _dd4950dc = () => interopDefault(import('../../../pages/start/cloud.vue' /* webpackChunkName: "pages/start/cloud" */))
const _946c4068 = () => interopDefault(import('../../../pages/start/dedicated.vue' /* webpackChunkName: "pages/start/dedicated" */))
const _f0c334b2 = () => interopDefault(import('../../../pages/start/vmware.vue' /* webpackChunkName: "pages/start/vmware" */))
const _5a0e7060 = () => interopDefault(import('../../../pages/thank-you/hr-subscribe.vue' /* webpackChunkName: "pages/thank-you/hr-subscribe" */))
const _66bbb181 = () => interopDefault(import('../../../pages/thank-you/subscribe.vue' /* webpackChunkName: "pages/thank-you/subscribe" */))
const _3b45cf14 = () => interopDefault(import('../../../pages/about/documents/archive/index.vue' /* webpackChunkName: "pages/about/documents/archive/index" */))
const _8e35246a = () => interopDefault(import('../../../pages/about/documents/personal-data/index.vue' /* webpackChunkName: "pages/about/documents/personal-data/index" */))
const _b96595ee = () => interopDefault(import('../../../pages/about/documents/restrictions/index.vue' /* webpackChunkName: "pages/about/documents/restrictions/index" */))
const _dc685394 = () => interopDefault(import('../../../pages/about/newsroom/materials/index.vue' /* webpackChunkName: "pages/about/newsroom/materials/index" */))
const _097816df = () => interopDefault(import('../../../pages/about/newsroom/news/index.vue' /* webpackChunkName: "pages/about/newsroom/news/index" */))
const _cf00cde6 = () => interopDefault(import('../../../pages/about/newsroom/press/index.vue' /* webpackChunkName: "pages/about/newsroom/press/index" */))
const _69c8c94c = () => interopDefault(import('../../../pages/about/partners/intel.vue' /* webpackChunkName: "pages/about/partners/intel" */))
const _5837495d = () => interopDefault(import('../../../pages/about/partners/referral-unlimited.vue' /* webpackChunkName: "pages/about/partners/referral-unlimited" */))
const _e9303274 = () => interopDefault(import('../../../pages/about/partners/veeam.vue' /* webpackChunkName: "pages/about/partners/veeam" */))
const _4607b640 = () => interopDefault(import('../../../pages/about/partners/vmware.vue' /* webpackChunkName: "pages/about/partners/vmware" */))
const _8e5596ee = () => interopDefault(import('../../../pages/about/payments/entities-pay/index.vue' /* webpackChunkName: "pages/about/payments/entities-pay/index" */))
const _074ca51e = () => interopDefault(import('../../../pages/about/payments/individuals-pay/index.vue' /* webpackChunkName: "pages/about/payments/individuals-pay/index" */))
const _ddb3d380 = () => interopDefault(import('../../../pages/careers/all/vacancy/index.vue' /* webpackChunkName: "pages/careers/all/vacancy/index" */))
const _b3b24cf6 = () => interopDefault(import('../../../pages/services/1c-leasing/1c-cloud/index.vue' /* webpackChunkName: "pages/services/1c-leasing/1c-cloud/index" */))
const _21147b96 = () => interopDefault(import('../../../pages/services/1c-leasing/1c-colo/index.vue' /* webpackChunkName: "pages/services/1c-leasing/1c-colo/index" */))
const _2c36d63f = () => interopDefault(import('../../../pages/services/1c-leasing/1c-dedicated/index.vue' /* webpackChunkName: "pages/services/1c-leasing/1c-dedicated/index" */))
const _03217f62 = () => interopDefault(import('../../../pages/services/additional/backup-as-a-service/index.vue' /* webpackChunkName: "pages/services/additional/backup-as-a-service/index" */))
const _3f9e01e3 = () => interopDefault(import('../../../pages/services/additional/cdn/index.vue' /* webpackChunkName: "pages/services/additional/cdn/index" */))
const _705218d8 = () => interopDefault(import('../../../pages/services/additional/ddos-protection/index.vue' /* webpackChunkName: "pages/services/additional/ddos-protection/index" */))
const _6388fbdf = () => interopDefault(import('../../../pages/services/additional/dns/index.vue' /* webpackChunkName: "pages/services/additional/dns/index" */))
const _892ff3c0 = () => interopDefault(import('../../../pages/services/additional/firewall/index.vue' /* webpackChunkName: "pages/services/additional/firewall/index" */))
const _05853302 = () => interopDefault(import('../../../pages/services/additional/local-network/index.vue' /* webpackChunkName: "pages/services/additional/local-network/index" */))
const _03344628 = () => interopDefault(import('../../../pages/services/additional/monitoring/index.vue' /* webpackChunkName: "pages/services/additional/monitoring/index" */))
const _69d9d443 = () => interopDefault(import('../../../pages/services/additional/rentsoft/index.vue' /* webpackChunkName: "pages/services/additional/rentsoft/index" */))
const _ae8f42ce = () => interopDefault(import('../../../pages/services/additional/rentvols/index.vue' /* webpackChunkName: "pages/services/additional/rentvols/index" */))
const _5e93743d = () => interopDefault(import('../../../pages/services/additional/veeam-cloud-connect/index.vue' /* webpackChunkName: "pages/services/additional/veeam-cloud-connect/index" */))
const _21e77dcc = () => interopDefault(import('../../../pages/services/additional/vrrp/index.vue' /* webpackChunkName: "pages/services/additional/vrrp/index" */))
const _3305bc1e = () => interopDefault(import('../../../pages/services/cloud-apps/google-workspace/index.vue' /* webpackChunkName: "pages/services/cloud-apps/google-workspace/index" */))
const _63b8678f = () => interopDefault(import('../../../pages/services/cloud-apps/office365/index.vue' /* webpackChunkName: "pages/services/cloud-apps/office365/index" */))
const _16730cb4 = () => interopDefault(import('../../../pages/services/cloud/info/index.vue' /* webpackChunkName: "pages/services/cloud/info/index" */))
const _0ac3c87e = () => interopDefault(import('../../../pages/services/cloud/kubernetes/index.vue' /* webpackChunkName: "pages/services/cloud/kubernetes/index" */))
const _fe95838a = () => interopDefault(import('../../../pages/services/cloud/load-balancer/index.vue' /* webpackChunkName: "pages/services/cloud/load-balancer/index" */))
const _6aafa008 = () => interopDefault(import('../../../pages/services/cloud/managed-databases/index.vue' /* webpackChunkName: "pages/services/cloud/managed-databases/index" */))
const _b89c5dd8 = () => interopDefault(import('../../../pages/services/cloud/serverless/index.vue' /* webpackChunkName: "pages/services/cloud/serverless/index" */))
const _cea3b7a4 = () => interopDefault(import('../../../pages/services/cloud/servers/index.vue' /* webpackChunkName: "pages/services/cloud/servers/index" */))
const _0800c359 = () => interopDefault(import('../../../pages/services/cloud/storage/index.vue' /* webpackChunkName: "pages/services/cloud/storage/index" */))
const _461f0fec = () => interopDefault(import('../../../pages/services/cloud/vmware/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/index" */))
const _9d445c72 = () => interopDefault(import('../../../pages/services/cloud/vpc/index.vue' /* webpackChunkName: "pages/services/cloud/vpc/index" */))
const _00ae0452 = () => interopDefault(import('../../../pages/services/cloud/vps/index.vue' /* webpackChunkName: "pages/services/cloud/vps/index" */))
const _0e72d388 = () => interopDefault(import('../../../pages/services/colocation/rentsquare/index.vue' /* webpackChunkName: "pages/services/colocation/rentsquare/index" */))
const _67bc62db = () => interopDefault(import('../../../pages/services/colocation/server-colocation/index.vue' /* webpackChunkName: "pages/services/colocation/server-colocation/index" */))
const _c498d55e = () => interopDefault(import('../../../pages/services/colocation/server-rack/index.vue' /* webpackChunkName: "pages/services/colocation/server-rack/index" */))
const _6dd2ec1c = () => interopDefault(import('../../../pages/services/dedicated/additional-services/index.vue' /* webpackChunkName: "pages/services/dedicated/additional-services/index" */))
const _a53bb8cc = () => interopDefault(import('../../../pages/services/dedicated/archive/index.vue' /* webpackChunkName: "pages/services/dedicated/archive/index" */))
const _16d246ae = () => interopDefault(import('../../../pages/services/dedicated/chipcore/index.vue' /* webpackChunkName: "pages/services/dedicated/chipcore/index" */))
const _0b999e00 = () => interopDefault(import('../../../pages/services/dedicated/config/index.vue' /* webpackChunkName: "pages/services/dedicated/config/index" */))
const _77527bf3 = () => interopDefault(import('../../../pages/services/dedicated/configurator/index.vue' /* webpackChunkName: "pages/services/dedicated/configurator/index" */))
const _1f761d84 = () => interopDefault(import('../../../pages/services/dedicated/gpu/index.vue' /* webpackChunkName: "pages/services/dedicated/gpu/index" */))
const _69e9fb32 = () => interopDefault(import('../../../pages/services/dedicated/mac/index.vue' /* webpackChunkName: "pages/services/dedicated/mac/index" */))
const _5e745949 = () => interopDefault(import('../../../pages/services/dedicated/preorder/index.vue' /* webpackChunkName: "pages/services/dedicated/preorder/index" */))
const _0e764585 = () => interopDefault(import('../../../pages/services/dedicated/sale/index.vue' /* webpackChunkName: "pages/services/dedicated/sale/index" */))
const _5b30d22f = () => interopDefault(import('../../../pages/services/is/dswes/index.vue' /* webpackChunkName: "pages/services/is/dswes/index" */))
const _3aed0495 = () => interopDefault(import('../../../pages/services/is/waf/index.vue' /* webpackChunkName: "pages/services/is/waf/index" */))
const _091b4605 = () => interopDefault(import('../../../pages/services/additional/backup-as-a-service/agent/index.vue' /* webpackChunkName: "pages/services/additional/backup-as-a-service/agent/index" */))
const _fc5b761a = () => interopDefault(import('../../../pages/services/additional/cdn/streaming.vue' /* webpackChunkName: "pages/services/additional/cdn/streaming" */))
const _d8fddeea = () => interopDefault(import('../../../pages/services/cloud/servers/gpu/index.vue' /* webpackChunkName: "pages/services/cloud/servers/gpu/index" */))
const _3ad744a1 = () => interopDefault(import('../../../pages/services/cloud/servers/prices/index.vue' /* webpackChunkName: "pages/services/cloud/servers/prices/index" */))
const _979b97e8 = () => interopDefault(import('../../../pages/services/cloud/vmware/152-fz/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/152-fz/index" */))
const _3bc9e1e2 = () => interopDefault(import('../../../pages/services/cloud/vmware/draas/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/draas/index" */))
const _31f5c01f = () => interopDefault(import('../../../pages/services/cloud/vmware/kubernetes/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/kubernetes/index" */))
const _0af7a278 = () => interopDefault(import('../../../pages/services/cloud/vmware/partners/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/partners/index" */))
const _2f65ae70 = () => interopDefault(import('../../../pages/services/cloud/vmware/private-cloud/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/private-cloud/index" */))
const _6b0b9d6a = () => interopDefault(import('../../../pages/services/cloud/vmware/public-cloud/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/public-cloud/index" */))
const _3334919e = () => interopDefault(import('../../../pages/services/cloud/vmware/vmware-backups/index.vue' /* webpackChunkName: "pages/services/cloud/vmware/vmware-backups/index" */))
const _8c4002d4 = () => interopDefault(import('../../../pages/services/colocation/server-rack/remote-smart/index.vue' /* webpackChunkName: "pages/services/colocation/server-rack/remote-smart/index" */))
const _07c17597 = () => interopDefault(import('../../../pages/about/newsroom/news/_slug.vue' /* webpackChunkName: "pages/about/newsroom/news/_slug" */))
const _d26e1076 = () => interopDefault(import('../../../pages/about/newsroom/press/_slug.vue' /* webpackChunkName: "pages/about/newsroom/press/_slug" */))
const _3fc4a8a8 = () => interopDefault(import('../../../pages/careers/all/vacancy/_id.vue' /* webpackChunkName: "pages/careers/all/vacancy/_id" */))
const _b0356920 = () => interopDefault(import('../../../pages/success-story/_slug.vue' /* webpackChunkName: "pages/success-story/_slug" */))
const _0359b3fa = () => interopDefault(import('../../../pages/wp/_slug.vue' /* webpackChunkName: "pages/wp/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404/",
    component: _70f3e482,
    pathToRegexpOptions: {"strict":true},
    name: "404___ru"
  }, {
    path: "/about/",
    component: _69d9b11a,
    pathToRegexpOptions: {"strict":true},
    name: "about___ru"
  }, {
    path: "/blog/",
    component: _2dba634b,
    pathToRegexpOptions: {"strict":true},
    name: "blog___ru"
  }, {
    path: "/careers/",
    component: _e31d807c,
    pathToRegexpOptions: {"strict":true},
    name: "careers___ru"
  }, {
    path: "/en/",
    component: _2742829c,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/events/",
    component: _10ba6082,
    pathToRegexpOptions: {"strict":true},
    name: "events___ru"
  }, {
    path: "/investors/",
    component: _395329e8,
    pathToRegexpOptions: {"strict":true},
    name: "investors___ru"
  }, {
    path: "/lab/",
    component: _12f1b39a,
    pathToRegexpOptions: {"strict":true},
    name: "lab___ru"
  }, {
    path: "/onboarding/",
    component: _6dff6404,
    pathToRegexpOptions: {"strict":true},
    name: "onboarding___ru"
  }, {
    path: "/prices/",
    component: _2efe6e73,
    pathToRegexpOptions: {"strict":true},
    name: "prices___ru"
  }, {
    path: "/promo/",
    component: _b4e647c8,
    pathToRegexpOptions: {"strict":true},
    name: "promo___ru"
  }, {
    path: "/services/",
    component: _1d5b5bf2,
    pathToRegexpOptions: {"strict":true},
    name: "services___ru"
  }, {
    path: "/solutions/",
    component: _7f953a67,
    pathToRegexpOptions: {"strict":true},
    name: "solutions___ru"
  }, {
    path: "/subscribe/",
    component: _128c7997,
    pathToRegexpOptions: {"strict":true},
    name: "subscribe___ru"
  }, {
    path: "/success-story/",
    component: _acc82690,
    pathToRegexpOptions: {"strict":true},
    name: "success-story___ru"
  }, {
    path: "/support/",
    component: _1f483e5c,
    pathToRegexpOptions: {"strict":true},
    name: "support___ru"
  }, {
    path: "/tenders/",
    component: _26b502ac,
    pathToRegexpOptions: {"strict":true},
    name: "tenders___ru"
  }, {
    path: "/wp/",
    component: _05105542,
    pathToRegexpOptions: {"strict":true},
    name: "wp___ru"
  }, {
    path: "/about/company/",
    component: _7d6b4a08,
    pathToRegexpOptions: {"strict":true},
    name: "about-company___ru"
  }, {
    path: "/about/conference-hall/",
    component: _1d82af95,
    pathToRegexpOptions: {"strict":true},
    name: "about-conference-hall___ru"
  }, {
    path: "/about/contacts/",
    component: _1f1532fe,
    pathToRegexpOptions: {"strict":true},
    name: "about-contacts___ru"
  }, {
    path: "/about/data-centers/",
    component: _62567846,
    pathToRegexpOptions: {"strict":true},
    name: "about-data-centers___ru"
  }, {
    path: "/about/details/",
    component: _1ebc4d8d,
    pathToRegexpOptions: {"strict":true},
    name: "about-details___ru"
  }, {
    path: "/about/documents/",
    component: _72562683,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents___ru"
  }, {
    path: "/about/newsroom/",
    component: _edf231ce,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom___ru"
  }, {
    path: "/about/partners-offers/",
    component: _e9d768f8,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-offers___ru"
  }, {
    path: "/about/partners/",
    component: _7d610156,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners___ru"
  }, {
    path: "/about/payments/",
    component: _96decd50,
    pathToRegexpOptions: {"strict":true},
    name: "about-payments___ru"
  }, {
    path: "/careers/all/",
    component: _fafd8658,
    pathToRegexpOptions: {"strict":true},
    name: "careers-all___ru"
  }, {
    path: "/careers/internships/",
    component: _38278fd0,
    pathToRegexpOptions: {"strict":true},
    name: "careers-internships___ru"
  }, {
    path: "/en/404/",
    component: _70f3e482,
    pathToRegexpOptions: {"strict":true},
    name: "404___en"
  }, {
    path: "/en/about/",
    component: _69d9b11a,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/blog/",
    component: _2dba634b,
    pathToRegexpOptions: {"strict":true},
    name: "blog___en"
  }, {
    path: "/en/careers/",
    component: _e31d807c,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en"
  }, {
    path: "/en/events/",
    component: _10ba6082,
    pathToRegexpOptions: {"strict":true},
    name: "events___en"
  }, {
    path: "/en/investors/",
    component: _395329e8,
    pathToRegexpOptions: {"strict":true},
    name: "investors___en"
  }, {
    path: "/en/lab/",
    component: _12f1b39a,
    pathToRegexpOptions: {"strict":true},
    name: "lab___en"
  }, {
    path: "/en/onboarding/",
    component: _6dff6404,
    pathToRegexpOptions: {"strict":true},
    name: "onboarding___en"
  }, {
    path: "/en/prices/",
    component: _2efe6e73,
    pathToRegexpOptions: {"strict":true},
    name: "prices___en"
  }, {
    path: "/en/promo/",
    component: _b4e647c8,
    pathToRegexpOptions: {"strict":true},
    name: "promo___en"
  }, {
    path: "/en/services/",
    component: _1d5b5bf2,
    pathToRegexpOptions: {"strict":true},
    name: "services___en"
  }, {
    path: "/en/solutions/",
    component: _7f953a67,
    pathToRegexpOptions: {"strict":true},
    name: "solutions___en"
  }, {
    path: "/en/subscribe/",
    component: _128c7997,
    pathToRegexpOptions: {"strict":true},
    name: "subscribe___en"
  }, {
    path: "/en/success-story/",
    component: _acc82690,
    pathToRegexpOptions: {"strict":true},
    name: "success-story___en"
  }, {
    path: "/en/support/",
    component: _1f483e5c,
    pathToRegexpOptions: {"strict":true},
    name: "support___en"
  }, {
    path: "/en/tenders/",
    component: _26b502ac,
    pathToRegexpOptions: {"strict":true},
    name: "tenders___en"
  }, {
    path: "/en/wp/",
    component: _05105542,
    pathToRegexpOptions: {"strict":true},
    name: "wp___en"
  }, {
    path: "/lab/amd/",
    component: _efffd7fa,
    pathToRegexpOptions: {"strict":true},
    name: "lab-amd___ru"
  }, {
    path: "/lab/anklav/",
    component: _01886b2e,
    pathToRegexpOptions: {"strict":true},
    name: "lab-anklav___ru"
  }, {
    path: "/lab/arm-server/",
    component: _94100282,
    pathToRegexpOptions: {"strict":true},
    name: "lab-arm-server___ru"
  }, {
    path: "/lab/fpga/",
    component: _5812060f,
    pathToRegexpOptions: {"strict":true},
    name: "lab-fpga___ru"
  }, {
    path: "/lab/general-load-balancer/",
    component: _b5f51f7a,
    pathToRegexpOptions: {"strict":true},
    name: "lab-general-load-balancer___ru"
  }, {
    path: "/lab/mac/",
    component: _7628224c,
    pathToRegexpOptions: {"strict":true},
    name: "lab-mac___ru"
  }, {
    path: "/services/1c-leasing/",
    component: _2787047a,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing___ru"
  }, {
    path: "/services/additional/",
    component: _58d4f6c5,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional___ru"
  }, {
    path: "/services/cloud-apps/",
    component: _a0aab430,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-apps___ru"
  }, {
    path: "/services/cloud/",
    component: _aa3ae626,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud___ru"
  }, {
    path: "/services/colocation/",
    component: _d89f6382,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation___ru"
  }, {
    path: "/services/dedicated/",
    component: _3b9a95a7,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated___ru"
  }, {
    path: "/services/is/",
    component: _7de1d708,
    pathToRegexpOptions: {"strict":true},
    name: "services-is___ru"
  }, {
    path: "/solutions/cdn-infrastructure/",
    component: _0c448781,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-cdn-infrastructure___ru"
  }, {
    path: "/solutions/cloud-migration/",
    component: _1e660fce,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-cloud-migration___ru"
  }, {
    path: "/solutions/data-center/",
    component: _1b203170,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-data-center___ru"
  }, {
    path: "/solutions/gpu/",
    component: _2fdf3b78,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-gpu___ru"
  }, {
    path: "/solutions/hybrid-cloud/",
    component: _6a50873c,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-hybrid-cloud___ru"
  }, {
    path: "/solutions/hybrid-infrastructure/",
    component: _32f43828,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-hybrid-infrastructure___ru"
  }, {
    path: "/solutions/hyperserver/",
    component: _1bb20987,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-hyperserver___ru"
  }, {
    path: "/solutions/it-cost-optimization/",
    component: _0803de6e,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-it-cost-optimization___ru"
  }, {
    path: "/solutions/managed-services/",
    component: _a6927eec,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-managed-services___ru"
  }, {
    path: "/solutions/multi-cloud/",
    component: _58488ef9,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-multi-cloud___ru"
  }, {
    path: "/solutions/pdps/",
    component: _7b46a916,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-pdps___ru"
  }, {
    path: "/solutions/resilient-infrastructure/",
    component: _a9899f6e,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-resilient-infrastructure___ru"
  }, {
    path: "/solutions/video-analytics/",
    component: _2b8eee68,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-video-analytics___ru"
  }, {
    path: "/start/cloud/",
    component: _dd4950dc,
    pathToRegexpOptions: {"strict":true},
    name: "start-cloud___ru"
  }, {
    path: "/start/dedicated/",
    component: _946c4068,
    pathToRegexpOptions: {"strict":true},
    name: "start-dedicated___ru"
  }, {
    path: "/start/vmware/",
    component: _f0c334b2,
    pathToRegexpOptions: {"strict":true},
    name: "start-vmware___ru"
  }, {
    path: "/thank-you/hr-subscribe/",
    component: _5a0e7060,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you-hr-subscribe___ru"
  }, {
    path: "/thank-you/subscribe/",
    component: _66bbb181,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you-subscribe___ru"
  }, {
    path: "/about/documents/archive/",
    component: _3b45cf14,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents-archive___ru"
  }, {
    path: "/about/documents/personal-data/",
    component: _8e35246a,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents-personal-data___ru"
  }, {
    path: "/about/documents/restrictions/",
    component: _b96595ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents-restrictions___ru"
  }, {
    path: "/about/newsroom/materials/",
    component: _dc685394,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-materials___ru"
  }, {
    path: "/about/newsroom/news/",
    component: _097816df,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-news___ru"
  }, {
    path: "/about/newsroom/press/",
    component: _cf00cde6,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-press___ru"
  }, {
    path: "/about/partners/intel/",
    component: _69c8c94c,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-intel___ru"
  }, {
    path: "/about/partners/referral-unlimited/",
    component: _5837495d,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-referral-unlimited___ru"
  }, {
    path: "/about/partners/veeam/",
    component: _e9303274,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-veeam___ru"
  }, {
    path: "/about/partners/vmware/",
    component: _4607b640,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-vmware___ru"
  }, {
    path: "/about/payments/entities-pay/",
    component: _8e5596ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-payments-entities-pay___ru"
  }, {
    path: "/about/payments/individuals-pay/",
    component: _074ca51e,
    pathToRegexpOptions: {"strict":true},
    name: "about-payments-individuals-pay___ru"
  }, {
    path: "/careers/all/vacancy/",
    component: _ddb3d380,
    pathToRegexpOptions: {"strict":true},
    name: "careers-all-vacancy___ru"
  }, {
    path: "/en/about/company/",
    component: _7d6b4a08,
    pathToRegexpOptions: {"strict":true},
    name: "about-company___en"
  }, {
    path: "/en/about/conference-hall/",
    component: _1d82af95,
    pathToRegexpOptions: {"strict":true},
    name: "about-conference-hall___en"
  }, {
    path: "/en/about/contacts/",
    component: _1f1532fe,
    pathToRegexpOptions: {"strict":true},
    name: "about-contacts___en"
  }, {
    path: "/en/about/data-centers/",
    component: _62567846,
    pathToRegexpOptions: {"strict":true},
    name: "about-data-centers___en"
  }, {
    path: "/en/about/details/",
    component: _1ebc4d8d,
    pathToRegexpOptions: {"strict":true},
    name: "about-details___en"
  }, {
    path: "/en/about/documents/",
    component: _72562683,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents___en"
  }, {
    path: "/en/about/newsroom/",
    component: _edf231ce,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom___en"
  }, {
    path: "/en/about/partners-offers/",
    component: _e9d768f8,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-offers___en"
  }, {
    path: "/en/about/partners/",
    component: _7d610156,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners___en"
  }, {
    path: "/en/about/payments/",
    component: _96decd50,
    pathToRegexpOptions: {"strict":true},
    name: "about-payments___en"
  }, {
    path: "/en/careers/all/",
    component: _fafd8658,
    pathToRegexpOptions: {"strict":true},
    name: "careers-all___en"
  }, {
    path: "/en/careers/internships/",
    component: _38278fd0,
    pathToRegexpOptions: {"strict":true},
    name: "careers-internships___en"
  }, {
    path: "/en/lab/amd/",
    component: _efffd7fa,
    pathToRegexpOptions: {"strict":true},
    name: "lab-amd___en"
  }, {
    path: "/en/lab/anklav/",
    component: _01886b2e,
    pathToRegexpOptions: {"strict":true},
    name: "lab-anklav___en"
  }, {
    path: "/en/lab/arm-server/",
    component: _94100282,
    pathToRegexpOptions: {"strict":true},
    name: "lab-arm-server___en"
  }, {
    path: "/en/lab/fpga/",
    component: _5812060f,
    pathToRegexpOptions: {"strict":true},
    name: "lab-fpga___en"
  }, {
    path: "/en/lab/general-load-balancer/",
    component: _b5f51f7a,
    pathToRegexpOptions: {"strict":true},
    name: "lab-general-load-balancer___en"
  }, {
    path: "/en/lab/mac/",
    component: _7628224c,
    pathToRegexpOptions: {"strict":true},
    name: "lab-mac___en"
  }, {
    path: "/en/services/1c-leasing/",
    component: _2787047a,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing___en"
  }, {
    path: "/en/services/additional/",
    component: _58d4f6c5,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional___en"
  }, {
    path: "/en/services/cloud-apps/",
    component: _a0aab430,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-apps___en"
  }, {
    path: "/en/services/cloud/",
    component: _aa3ae626,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud___en"
  }, {
    path: "/en/services/colocation/",
    component: _d89f6382,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation___en"
  }, {
    path: "/en/services/dedicated/",
    component: _3b9a95a7,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated___en"
  }, {
    path: "/en/services/is/",
    component: _7de1d708,
    pathToRegexpOptions: {"strict":true},
    name: "services-is___en"
  }, {
    path: "/en/solutions/cdn-infrastructure/",
    component: _0c448781,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-cdn-infrastructure___en"
  }, {
    path: "/en/solutions/cloud-migration/",
    component: _1e660fce,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-cloud-migration___en"
  }, {
    path: "/en/solutions/data-center/",
    component: _1b203170,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-data-center___en"
  }, {
    path: "/en/solutions/gpu/",
    component: _2fdf3b78,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-gpu___en"
  }, {
    path: "/en/solutions/hybrid-cloud/",
    component: _6a50873c,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-hybrid-cloud___en"
  }, {
    path: "/en/solutions/hybrid-infrastructure/",
    component: _32f43828,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-hybrid-infrastructure___en"
  }, {
    path: "/en/solutions/hyperserver/",
    component: _1bb20987,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-hyperserver___en"
  }, {
    path: "/en/solutions/it-cost-optimization/",
    component: _0803de6e,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-it-cost-optimization___en"
  }, {
    path: "/en/solutions/managed-services/",
    component: _a6927eec,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-managed-services___en"
  }, {
    path: "/en/solutions/multi-cloud/",
    component: _58488ef9,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-multi-cloud___en"
  }, {
    path: "/en/solutions/pdps/",
    component: _7b46a916,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-pdps___en"
  }, {
    path: "/en/solutions/resilient-infrastructure/",
    component: _a9899f6e,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-resilient-infrastructure___en"
  }, {
    path: "/en/solutions/video-analytics/",
    component: _2b8eee68,
    pathToRegexpOptions: {"strict":true},
    name: "solutions-video-analytics___en"
  }, {
    path: "/en/start/cloud/",
    component: _dd4950dc,
    pathToRegexpOptions: {"strict":true},
    name: "start-cloud___en"
  }, {
    path: "/en/start/dedicated/",
    component: _946c4068,
    pathToRegexpOptions: {"strict":true},
    name: "start-dedicated___en"
  }, {
    path: "/en/start/vmware/",
    component: _f0c334b2,
    pathToRegexpOptions: {"strict":true},
    name: "start-vmware___en"
  }, {
    path: "/en/thank-you/hr-subscribe/",
    component: _5a0e7060,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you-hr-subscribe___en"
  }, {
    path: "/en/thank-you/subscribe/",
    component: _66bbb181,
    pathToRegexpOptions: {"strict":true},
    name: "thank-you-subscribe___en"
  }, {
    path: "/services/1c-leasing/1c-cloud/",
    component: _b3b24cf6,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing-1c-cloud___ru"
  }, {
    path: "/services/1c-leasing/1c-colo/",
    component: _21147b96,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing-1c-colo___ru"
  }, {
    path: "/services/1c-leasing/1c-dedicated/",
    component: _2c36d63f,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing-1c-dedicated___ru"
  }, {
    path: "/services/additional/backup-as-a-service/",
    component: _03217f62,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-backup-as-a-service___ru"
  }, {
    path: "/services/additional/cdn/",
    component: _3f9e01e3,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-cdn___ru"
  }, {
    path: "/services/additional/ddos-protection/",
    component: _705218d8,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-ddos-protection___ru"
  }, {
    path: "/services/additional/dns/",
    component: _6388fbdf,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-dns___ru"
  }, {
    path: "/services/additional/firewall/",
    component: _892ff3c0,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-firewall___ru"
  }, {
    path: "/services/additional/local-network/",
    component: _05853302,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-local-network___ru"
  }, {
    path: "/services/additional/monitoring/",
    component: _03344628,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-monitoring___ru"
  }, {
    path: "/services/additional/rentsoft/",
    component: _69d9d443,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-rentsoft___ru"
  }, {
    path: "/services/additional/rentvols/",
    component: _ae8f42ce,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-rentvols___ru"
  }, {
    path: "/services/additional/veeam-cloud-connect/",
    component: _5e93743d,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-veeam-cloud-connect___ru"
  }, {
    path: "/services/additional/vrrp/",
    component: _21e77dcc,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-vrrp___ru"
  }, {
    path: "/services/cloud-apps/google-workspace/",
    component: _3305bc1e,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-apps-google-workspace___ru"
  }, {
    path: "/services/cloud-apps/office365/",
    component: _63b8678f,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-apps-office365___ru"
  }, {
    path: "/services/cloud/info/",
    component: _16730cb4,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-info___ru"
  }, {
    path: "/services/cloud/kubernetes/",
    component: _0ac3c87e,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-kubernetes___ru"
  }, {
    path: "/services/cloud/load-balancer/",
    component: _fe95838a,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-load-balancer___ru"
  }, {
    path: "/services/cloud/managed-databases/",
    component: _6aafa008,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-managed-databases___ru"
  }, {
    path: "/services/cloud/serverless/",
    component: _b89c5dd8,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-serverless___ru"
  }, {
    path: "/services/cloud/servers/",
    component: _cea3b7a4,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-servers___ru"
  }, {
    path: "/services/cloud/storage/",
    component: _0800c359,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-storage___ru"
  }, {
    path: "/services/cloud/vmware/",
    component: _461f0fec,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware___ru"
  }, {
    path: "/services/cloud/vpc/",
    component: _9d445c72,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vpc___ru"
  }, {
    path: "/services/cloud/vps/",
    component: _00ae0452,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vps___ru"
  }, {
    path: "/services/colocation/rentsquare/",
    component: _0e72d388,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-rentsquare___ru"
  }, {
    path: "/services/colocation/server-colocation/",
    component: _67bc62db,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-server-colocation___ru"
  }, {
    path: "/services/colocation/server-rack/",
    component: _c498d55e,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-server-rack___ru"
  }, {
    path: "/services/dedicated/additional-services/",
    component: _6dd2ec1c,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-additional-services___ru"
  }, {
    path: "/services/dedicated/archive/",
    component: _a53bb8cc,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-archive___ru"
  }, {
    path: "/services/dedicated/chipcore/",
    component: _16d246ae,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-chipcore___ru"
  }, {
    path: "/services/dedicated/config/",
    component: _0b999e00,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-config___ru"
  }, {
    path: "/services/dedicated/configurator/",
    component: _77527bf3,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-configurator___ru"
  }, {
    path: "/services/dedicated/gpu/",
    component: _1f761d84,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-gpu___ru"
  }, {
    path: "/services/dedicated/mac/",
    component: _69e9fb32,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-mac___ru"
  }, {
    path: "/services/dedicated/preorder/",
    component: _5e745949,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-preorder___ru"
  }, {
    path: "/services/dedicated/sale/",
    component: _0e764585,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-sale___ru"
  }, {
    path: "/services/is/dswes/",
    component: _5b30d22f,
    pathToRegexpOptions: {"strict":true},
    name: "services-is-dswes___ru"
  }, {
    path: "/services/is/waf/",
    component: _3aed0495,
    pathToRegexpOptions: {"strict":true},
    name: "services-is-waf___ru"
  }, {
    path: "/en/about/documents/archive/",
    component: _3b45cf14,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents-archive___en"
  }, {
    path: "/en/about/documents/personal-data/",
    component: _8e35246a,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents-personal-data___en"
  }, {
    path: "/en/about/documents/restrictions/",
    component: _b96595ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-documents-restrictions___en"
  }, {
    path: "/en/about/newsroom/materials/",
    component: _dc685394,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-materials___en"
  }, {
    path: "/en/about/newsroom/news/",
    component: _097816df,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-news___en"
  }, {
    path: "/en/about/newsroom/press/",
    component: _cf00cde6,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-press___en"
  }, {
    path: "/en/about/partners/intel/",
    component: _69c8c94c,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-intel___en"
  }, {
    path: "/en/about/partners/referral-unlimited/",
    component: _5837495d,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-referral-unlimited___en"
  }, {
    path: "/en/about/partners/veeam/",
    component: _e9303274,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-veeam___en"
  }, {
    path: "/en/about/partners/vmware/",
    component: _4607b640,
    pathToRegexpOptions: {"strict":true},
    name: "about-partners-vmware___en"
  }, {
    path: "/en/about/payments/entities-pay/",
    component: _8e5596ee,
    pathToRegexpOptions: {"strict":true},
    name: "about-payments-entities-pay___en"
  }, {
    path: "/en/about/payments/individuals-pay/",
    component: _074ca51e,
    pathToRegexpOptions: {"strict":true},
    name: "about-payments-individuals-pay___en"
  }, {
    path: "/en/careers/all/vacancy/",
    component: _ddb3d380,
    pathToRegexpOptions: {"strict":true},
    name: "careers-all-vacancy___en"
  }, {
    path: "/en/services/1c-leasing/1c-cloud/",
    component: _b3b24cf6,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing-1c-cloud___en"
  }, {
    path: "/en/services/1c-leasing/1c-colo/",
    component: _21147b96,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing-1c-colo___en"
  }, {
    path: "/en/services/1c-leasing/1c-dedicated/",
    component: _2c36d63f,
    pathToRegexpOptions: {"strict":true},
    name: "services-1c-leasing-1c-dedicated___en"
  }, {
    path: "/en/services/additional/backup-as-a-service/",
    component: _03217f62,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-backup-as-a-service___en"
  }, {
    path: "/en/services/additional/cdn/",
    component: _3f9e01e3,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-cdn___en"
  }, {
    path: "/en/services/additional/ddos-protection/",
    component: _705218d8,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-ddos-protection___en"
  }, {
    path: "/en/services/additional/dns/",
    component: _6388fbdf,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-dns___en"
  }, {
    path: "/en/services/additional/firewall/",
    component: _892ff3c0,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-firewall___en"
  }, {
    path: "/en/services/additional/local-network/",
    component: _05853302,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-local-network___en"
  }, {
    path: "/en/services/additional/monitoring/",
    component: _03344628,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-monitoring___en"
  }, {
    path: "/en/services/additional/rentsoft/",
    component: _69d9d443,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-rentsoft___en"
  }, {
    path: "/en/services/additional/rentvols/",
    component: _ae8f42ce,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-rentvols___en"
  }, {
    path: "/en/services/additional/veeam-cloud-connect/",
    component: _5e93743d,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-veeam-cloud-connect___en"
  }, {
    path: "/en/services/additional/vrrp/",
    component: _21e77dcc,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-vrrp___en"
  }, {
    path: "/en/services/cloud-apps/google-workspace/",
    component: _3305bc1e,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-apps-google-workspace___en"
  }, {
    path: "/en/services/cloud-apps/office365/",
    component: _63b8678f,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-apps-office365___en"
  }, {
    path: "/en/services/cloud/info/",
    component: _16730cb4,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-info___en"
  }, {
    path: "/en/services/cloud/kubernetes/",
    component: _0ac3c87e,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-kubernetes___en"
  }, {
    path: "/en/services/cloud/load-balancer/",
    component: _fe95838a,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-load-balancer___en"
  }, {
    path: "/en/services/cloud/managed-databases/",
    component: _6aafa008,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-managed-databases___en"
  }, {
    path: "/en/services/cloud/serverless/",
    component: _b89c5dd8,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-serverless___en"
  }, {
    path: "/en/services/cloud/servers/",
    component: _cea3b7a4,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-servers___en"
  }, {
    path: "/en/services/cloud/storage/",
    component: _0800c359,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-storage___en"
  }, {
    path: "/en/services/cloud/vmware/",
    component: _461f0fec,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware___en"
  }, {
    path: "/en/services/cloud/vpc/",
    component: _9d445c72,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vpc___en"
  }, {
    path: "/en/services/cloud/vps/",
    component: _00ae0452,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vps___en"
  }, {
    path: "/en/services/colocation/rentsquare/",
    component: _0e72d388,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-rentsquare___en"
  }, {
    path: "/en/services/colocation/server-colocation/",
    component: _67bc62db,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-server-colocation___en"
  }, {
    path: "/en/services/colocation/server-rack/",
    component: _c498d55e,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-server-rack___en"
  }, {
    path: "/en/services/dedicated/additional-services/",
    component: _6dd2ec1c,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-additional-services___en"
  }, {
    path: "/en/services/dedicated/archive/",
    component: _a53bb8cc,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-archive___en"
  }, {
    path: "/en/services/dedicated/chipcore/",
    component: _16d246ae,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-chipcore___en"
  }, {
    path: "/en/services/dedicated/config/",
    component: _0b999e00,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-config___en"
  }, {
    path: "/en/services/dedicated/configurator/",
    component: _77527bf3,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-configurator___en"
  }, {
    path: "/en/services/dedicated/gpu/",
    component: _1f761d84,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-gpu___en"
  }, {
    path: "/en/services/dedicated/mac/",
    component: _69e9fb32,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-mac___en"
  }, {
    path: "/en/services/dedicated/preorder/",
    component: _5e745949,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-preorder___en"
  }, {
    path: "/en/services/dedicated/sale/",
    component: _0e764585,
    pathToRegexpOptions: {"strict":true},
    name: "services-dedicated-sale___en"
  }, {
    path: "/en/services/is/dswes/",
    component: _5b30d22f,
    pathToRegexpOptions: {"strict":true},
    name: "services-is-dswes___en"
  }, {
    path: "/en/services/is/waf/",
    component: _3aed0495,
    pathToRegexpOptions: {"strict":true},
    name: "services-is-waf___en"
  }, {
    path: "/services/additional/backup-as-a-service/agent/",
    component: _091b4605,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-backup-as-a-service-agent___ru"
  }, {
    path: "/services/additional/cdn/streaming/",
    component: _fc5b761a,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-cdn-streaming___ru"
  }, {
    path: "/services/cloud/servers/gpu/",
    component: _d8fddeea,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-servers-gpu___ru"
  }, {
    path: "/services/cloud/servers/prices/",
    component: _3ad744a1,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-servers-prices___ru"
  }, {
    path: "/services/cloud/vmware/152-fz/",
    component: _979b97e8,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-152-fz___ru"
  }, {
    path: "/services/cloud/vmware/draas/",
    component: _3bc9e1e2,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-draas___ru"
  }, {
    path: "/services/cloud/vmware/kubernetes/",
    component: _31f5c01f,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-kubernetes___ru"
  }, {
    path: "/services/cloud/vmware/partners/",
    component: _0af7a278,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-partners___ru"
  }, {
    path: "/services/cloud/vmware/private-cloud/",
    component: _2f65ae70,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-private-cloud___ru"
  }, {
    path: "/services/cloud/vmware/public-cloud/",
    component: _6b0b9d6a,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-public-cloud___ru"
  }, {
    path: "/services/cloud/vmware/vmware-backups/",
    component: _3334919e,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-vmware-backups___ru"
  }, {
    path: "/services/colocation/server-rack/remote-smart/",
    component: _8c4002d4,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-server-rack-remote-smart___ru"
  }, {
    path: "/en/services/additional/backup-as-a-service/agent/",
    component: _091b4605,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-backup-as-a-service-agent___en"
  }, {
    path: "/en/services/additional/cdn/streaming/",
    component: _fc5b761a,
    pathToRegexpOptions: {"strict":true},
    name: "services-additional-cdn-streaming___en"
  }, {
    path: "/en/services/cloud/servers/gpu/",
    component: _d8fddeea,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-servers-gpu___en"
  }, {
    path: "/en/services/cloud/servers/prices/",
    component: _3ad744a1,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-servers-prices___en"
  }, {
    path: "/en/services/cloud/vmware/152-fz/",
    component: _979b97e8,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-152-fz___en"
  }, {
    path: "/en/services/cloud/vmware/draas/",
    component: _3bc9e1e2,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-draas___en"
  }, {
    path: "/en/services/cloud/vmware/kubernetes/",
    component: _31f5c01f,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-kubernetes___en"
  }, {
    path: "/en/services/cloud/vmware/partners/",
    component: _0af7a278,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-partners___en"
  }, {
    path: "/en/services/cloud/vmware/private-cloud/",
    component: _2f65ae70,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-private-cloud___en"
  }, {
    path: "/en/services/cloud/vmware/public-cloud/",
    component: _6b0b9d6a,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-public-cloud___en"
  }, {
    path: "/en/services/cloud/vmware/vmware-backups/",
    component: _3334919e,
    pathToRegexpOptions: {"strict":true},
    name: "services-cloud-vmware-vmware-backups___en"
  }, {
    path: "/en/services/colocation/server-rack/remote-smart/",
    component: _8c4002d4,
    pathToRegexpOptions: {"strict":true},
    name: "services-colocation-server-rack-remote-smart___en"
  }, {
    path: "/en/about/newsroom/news/:slug/",
    component: _07c17597,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-news-slug___en"
  }, {
    path: "/en/about/newsroom/press/:slug/",
    component: _d26e1076,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-press-slug___en"
  }, {
    path: "/en/careers/all/vacancy/:id/",
    component: _3fc4a8a8,
    pathToRegexpOptions: {"strict":true},
    name: "careers-all-vacancy-id___en"
  }, {
    path: "/about/newsroom/news/:slug/",
    component: _07c17597,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-news-slug___ru"
  }, {
    path: "/about/newsroom/press/:slug/",
    component: _d26e1076,
    pathToRegexpOptions: {"strict":true},
    name: "about-newsroom-press-slug___ru"
  }, {
    path: "/careers/all/vacancy/:id/",
    component: _3fc4a8a8,
    pathToRegexpOptions: {"strict":true},
    name: "careers-all-vacancy-id___ru"
  }, {
    path: "/en/success-story/:slug?/",
    component: _b0356920,
    pathToRegexpOptions: {"strict":true},
    name: "success-story-slug___en"
  }, {
    path: "/en/wp/:slug/",
    component: _0359b3fa,
    pathToRegexpOptions: {"strict":true},
    name: "wp-slug___en"
  }, {
    path: "/success-story/:slug?/",
    component: _b0356920,
    pathToRegexpOptions: {"strict":true},
    name: "success-story-slug___ru"
  }, {
    path: "/wp/:slug/",
    component: _0359b3fa,
    pathToRegexpOptions: {"strict":true},
    name: "wp-slug___ru"
  }, {
    path: "/",
    component: _2742829c,
    pathToRegexpOptions: {"strict":true},
    name: "index___ru"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
